(() => {
  if (window.__postorFullCartCroInitialized) return;
  window.__postorFullCartCroInitialized = true;

  let queued = false;

  function decorateFullCart() {
    queued = false;

    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      const titleWrapper = cartItems.querySelector('.title-wrapper-with-link');
      const title = titleWrapper && titleWrapper.querySelector('.title');

      if (titleWrapper && title && !titleWrapper.querySelector('.postor-cart-page-heading-group')) {
        const group = document.createElement('div');
        group.className = 'postor-cart-page-heading-group';
        title.parentNode.insertBefore(group, title);
        group.appendChild(title);

        const subtitle = document.createElement('p');
        subtitle.className = 'postor-cart-page-subtitle';
        subtitle.textContent = 'Review your items and continue when you’re ready.';
        group.appendChild(subtitle);
      }
    }

    const footer = document.querySelector('#main-cart-footer');
    if (!footer) return;

    const checkout = footer.querySelector('#checkout');
    if (checkout) {
      checkout.textContent = 'Proceed to Checkout';
      checkout.setAttribute('aria-label', 'Proceed to Checkout');
    }

    const ctas = checkout && checkout.closest('.cart__ctas');
    if (ctas && !ctas.querySelector('.postor-cart-page-checkout-note')) {
      const note = document.createElement('p');
      note.className = 'postor-cart-page-checkout-note';
      note.textContent = 'Delivery and payment details are confirmed at checkout.';
      ctas.appendChild(note);
    }

    const blocks = footer.querySelector('.cart__blocks');
    if (blocks && !blocks.querySelector('.postor-cart-page-continue')) {
      const continueLink = document.createElement('a');
      continueLink.className = 'postor-cart-page-continue';
      continueLink.href = '/collections/all';
      continueLink.textContent = 'Continue shopping';
      blocks.appendChild(continueLink);
    }
  }

  function queueDecoration() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(decorateFullCart);
  }

  function init() {
    decorateFullCart();

    const footer = document.querySelector('#main-cart-footer');
    if (footer) {
      const observer = new MutationObserver(queueDecoration);
      observer.observe(footer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
